import React from 'react';
import { motion } from 'framer-motion';
import { Box } from 'lucide-react';

export const CanvasLoader = () => {
    return (
        <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-b from-gray-50 to-white z-10">
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                className="text-center"
            >
                {/* Animated 3D box icon */}
                <motion.div
                    animate={{ 
                        rotateY: [0, 360],
                    }}
                    transition={{ 
                        duration: 2, 
                        repeat: Infinity, 
                        ease: "linear" 
                    }}
                    className="w-20 h-20 mx-auto mb-6 bg-blue-100 rounded-2xl flex items-center justify-center shadow-lg"
                >
                    <Box className="w-10 h-10 text-blue-600" />
                </motion.div>
                
                {/* Loading text */}
                <h3 className="text-lg font-bold text-gray-800 mb-2">
                    Loading 3D Model
                </h3>
                <p className="text-sm text-gray-500 mb-4">
                    Preparing the interactive visualization...
                </p>
                
                {/* Progress bar */}
                <div className="w-48 h-1 bg-gray-200 rounded-full overflow-hidden mx-auto">
                    <motion.div
                        className="h-full bg-blue-600 rounded-full"
                        initial={{ width: "0%" }}
                        animate={{ width: "100%" }}
                        transition={{ 
                            duration: 1.5, 
                            repeat: Infinity,
                            ease: "easeInOut"
                        }}
                    />
                </div>
            </motion.div>
        </div>
    );
};

export default CanvasLoader;
